import React from 'react';
import styled from 'styled-components';
import { statusColors } from '../styles/adminTheme';

const Badge = styled.span<{ $bg: string; $color: string }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  background: ${p => p.$bg};
  color: ${p => p.$color};
  text-transform: capitalize;
`;

interface StatusBadgeProps {
  status: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const colors = statusColors[status] || { bg: '#f1f3f4', text: '#5f6368' };
  return <Badge $bg={colors.bg} $color={colors.text}>{status}</Badge>;
};
